import styled from 'styled-components';
import color from '../../configs/color';

export const Wrapper = styled.div`
  min-width: 900px;
  display: flex;
  overflow: auto;
  height: 100vh;
`;

export const FormSign = styled.div`
  flex: 1;
  position: relative;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding-top: 100px;
`;

export const BannerWrapper = styled.div`
  flex: 1;
  position: relative;
  display: grid;
  background-color: ${color.grey3};

  .component_banner_logo {
    padding: 40px 0px 0px 72px;

    display: inline-block;
    height: 79px;
  }

  .component_banner_image {
    width: 100%;
    display: flex;
    align-items: center;

    img {
      margin: auto;
      margin-top: -20px;
      width: 500px;
    }
  }

  .component_banner_footer {
    margin-left: 72px;
  }
`;
